// extracted by mini-css-extract-plugin
export default {"headerActions":"permissionsList_headerActions__jfbvi"};